import React from 'react';

const Icon = ({ name, className }) => {
  const icons = window.lucide;
  return icons ? React.createElement(icons[name], { className }) : null;
};

export default Icon;
